import { useEffect } from 'react';
import { useNavigation } from '@react-navigation/native';
import type { ShellStackParamList } from '../../shell/navigation/shellStackParamList';

type Target = keyof Pick<
  ShellStackParamList,
  'BusinessFunctions' | 'OperationMode' | 'CapabilityBreakdown' | 'AddFeatures'
>;

export function DeprecatedSettingsRedirectScreen({ target }: { target: Target }) {
  const navigation = useNavigation<any>();

  useEffect(() => {
    navigation.replace(target);
  }, [navigation, target]);

  return null;
}
